import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaToast } from "./VaToast-b32ca62f.mjs";
const VaToast = withConfigTransport(_VaToast);
export {
  VaToast as V
};
//# sourceMappingURL=index-72dd896d.mjs.map
